module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"myExams":"Meine Prüfungen"},"en":{"myExams":"My exams"}}')
  delete Component.options._Ctor
}
